angular.module('mtic.components.login')
.component('mticFinalizationAccountReturning', {
  
  templateUrl: 'template.html',

  bindings: {
    'flow': '='
  },
  
  controllerAs: 'ret',

  controller(
    $scope, 
    EventManager, 
    userAccount, 
    IAM_CODES
  ){
    
    var eventManager = new EventManager('mticFinalizationAccountReturning', $scope);
    
    var ret = this;

    ret.isSelected = function(id){
      var isSelected = ret.flow.returningType === id;
      if(isSelected){
        return {
          'button': true,
          'btn-new-mtic': true,
          'selected': true
        }
      }
      else{
        return {
          'button': true,
          'btn-new-mtic': true,
          'not-selected': true
        }
      }
    }

    ret.setType = function(id){
      if(!ret.teacherSelected()) {
        ret.flow.setType(id, 'returning')
      }
      else{
        ret.flow.setType(IAM_CODES.LANG.RETURNING, 'returning')
      }
    };

    ret.teacherSelected = function(){
      return Number(ret.flow.accountType) === IAM_CODES.LANG.TEACHER
    }

  }
});
